export default __webpack_public_path__ + "static/custom-LMS-integrating-design-tools-d22122c6fead5297194443c719cfaf23.jpg";